import globalStore, { type Theme } from '@src/store/common/global' // 这是 create() 返回的 store 实例
import type { PrimaryHue } from '@src/theme/palette'
import systemConfig from '@src/config'
import { getLocalStorage } from '@src/utils/storage'

export const chinaNumChar = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']

export const columnDefaultWidth = 120

export const columnSmallWidth = 60

export const columnLargeWidth = 200

export const FormItemDefaultWidth = 250

export const SheetDefaultWidth = 600

// Modal 顶部垂直偏移(像素)。Semi Modal 默认 top 是 vh 单位相对值,
// 靠它在不同屏高下位置飘忽,项目惯例显式指定 40px 与 header 84px 配合。
// 改这里全项目生效 —— 见 CLAUDE.md "Modal 顶部走 modalTopOffset 常量" 那条。
export const modalTopOffset = 40

// utils 或 constants 文件中
export const selectLocale = (locale: 'zh_CN' | 'en_GB') => {
	globalStore.getState().changeLocale(locale)
	localStorage.setItem('plus_one_locale', locale)
}

export const switchMode = (clickX?: number, clickY?: number) => {
	globalStore.getState().switchMode(clickX, clickY)
}
export const setPrimaryHue = (h: PrimaryHue) => globalStore.getState().setPrimaryHue(h)
export const setTheme = (t: Theme, opts?: { x?: number; y?: number }) => globalStore.getState().setTheme(t, opts)
export const imgList = [
	'https://lf3-static.bytednsdoc.com/obj/eden-cn/hjeh7pldnulm/SemiDocs/bg-1.png',
	'https://lf3-static.bytednsdoc.com/obj/eden-cn/hjeh7pldnulm/SemiDocs/bg-2.png',
	'https://lf3-static.bytednsdoc.com/obj/eden-cn/hjeh7pldnulm/SemiDocs/bg-3.png'
]

export const textList = [
	['Plus One UI', '', '基于 Semi-design 快速部署您的管理系统'],
	['Plus One UI', '', '基于 Semi-design 快速部署您的管理系统'],
	['Plus One UI', '', '基于 Semi-design 快速部署您的管理系统']
]

/**
 * 拼接 SSE 端点 URL。
 *
 * 后端走通用 `/sse/{topic}/stream` 模式，topic 是业务名（单段路径），例如 `unreadCount` / `orderUpdate`。
 *
 * - base 规则跟 `src/utils/request/index.ts` 一致：
 *   - dev 用 `apiPrefix`（`/plus-one`）走 devServer proxy
 *   - 非 dev 用 `VITE_BASE_API`
 * - 鉴权 token 从 localStorage 读，走 query 参数（浏览器原生 EventSource 不支持自定义请求头）。
 *   token 不存在时省略 query 后缀。
 *
 * @example
 *   buildSSEUrl('unreadCount')
 *   // dev:   '/plus-one/sse/unreadCount/stream?satoken=xxx'
 *   // prod:  '/api/sse/unreadCount/stream?satoken=xxx'
 */
export const buildSSEUrl = (topic: string): string => {
	if (!topic) {
		throw new Error('[buildSSEUrl] topic 不能为空')
	}
	// ⚠️ dev 模式临时：直连后端 8080 绕开 webpack-dev-server proxy 的 SSE 缓冲问题
	// TODO：等 webpack 代理修好之后改回 import.meta.env.MODE === 'development' ? systemConfig.apiPrefix : ...
	const basePrefix =
		import.meta.env.MODE === 'development' ? 'http://localhost:8080/plus-one' : import.meta.env.VITE_BASE_API || ''
	const token = getLocalStorage(systemConfig.authKey)
	const tokenQuery = token ? `?${systemConfig.authKey}=${encodeURIComponent(token)}` : ''
	return `${basePrefix}/sse/${topic}/stream${tokenQuery}`
}
